"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./Table.scss");
const Table = _ref => {
  let {
    category,
    className,
    manufacturerSku,
    onCategoryClick,
    sku,
    renderSku,
    text
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-ProductBox-Table', 'cds-Table', 'cds-Table--FeaturesSmall', className);
  return /*#__PURE__*/_react.default.createElement("table", {
    className: rootClassName
  }, /*#__PURE__*/_react.default.createElement("tbody", null, sku ? /*#__PURE__*/_react.default.createElement("tr", {
    className: "cds-ProductBox-SKU"
  }, /*#__PURE__*/_react.default.createElement("td", {
    className: "cds-ProductBox-AttrLabel"
  }, text.sku, ":"), /*#__PURE__*/_react.default.createElement("td", {
    className: "cds-ProductBox-AttrValue"
  }, renderSku?.(sku) || sku)) : null, manufacturerSku ? /*#__PURE__*/_react.default.createElement("tr", {
    className: "cds-ProductBox-SKU"
  }, /*#__PURE__*/_react.default.createElement("td", {
    className: "cds-ProductBox-AttrLabel"
  }, text.manufacturerSku, ":"), /*#__PURE__*/_react.default.createElement("td", {
    className: "cds-ProductBox-AttrValue"
  }, renderSku?.(manufacturerSku) || manufacturerSku)) : null, category ? /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    className: "cds-ProductBox-AttrLabel"
  }, text.category, ":"), /*#__PURE__*/_react.default.createElement("td", {
    className: "cds-ProductBox-AttrValue"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "cds-Link",
    href: category.url,
    onClick: onCategoryClick(category.url)
  }, category.label))) : null));
};
exports.Table = Table;
//# sourceMappingURL=Table.js.map